import { APP_INITIALIZER, ErrorHandler, InjectionToken, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '@environments/environment';

import { AngularFireAuthModule, PERSISTENCE } from '@angular/fire/compat/auth';
import { USE_DEVICE_LANGUAGE } from '@angular/fire/compat/auth';

import { ApiAuthenticatedService, ApiModule } from '@app/api/api.module';

// import {
//   provideAnalytics,
//   getAnalytics,
//   ScreenTrackingService,
//   UserTrackingService,
// } from '@angular/fire/analytics';
// import { provideAuth, getAuth } from '@angular/fire/auth';
// import { AuthModule } from './auth/auth.module';
import { AngularFireModule } from '@angular/fire/compat';
// import { provideDatabase, getDatabase } from '@angular/fire/database';
// import { provideFirestore, getFirestore } from '@angular/fire/firestore';
// import { provideFunctions, getFunctions } from '@angular/fire/functions';
// import { provideMessaging, getMessaging } from '@angular/fire/messaging';
// import { providePerformance, getPerformance } from '@angular/fire/performance';
// import {
//   provideRemoteConfig,
//   getRemoteConfig,
// } from '@angular/fire/remote-config';
// import { provideStorage, getStorage } from '@angular/fire/storage';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AfterLoginComponent } from '@app/after-login/after-login.component';
import { AccountService } from '@app/services/account.service';
import { MessagingService } from '@app/services/messaging.service';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AuthorizedLayoutComponent } from '@app/layout/authorized-layout/authorized-layout.component';
import { UnauthorizedLayoutComponent } from '@app/layout/unauthorized-layout/unauthorized-layout.component';
import { ProjectsService } from '@app/services/project.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { QuillModule } from 'ngx-quill';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { MarkdownModule } from 'ngx-markdown';
import { authInterceptorFn } from '@app/api/auth.interceptor.fn';
import { coldStartInterceptorFn } from '@app/services/cold-start.interceptor.fn';
import { featureGate403InterceptorFn } from '@app/api/feature-gate.interceptor.fn';
import { BackendLoadingComponent } from '@app/shared/backend-loading/backend-loading.component';
import { GlobalErrorHandler } from '@app/services/global-error-handler.service';
import { ReferralService } from '@app/services/referral.service';
// import { WrappedRouterOutletDirective } from './layout/wrapped-router-outlet.directive';
// import { getMessaging, provideMessaging } from '@angular/fire/messaging';

@NgModule({
  declarations: [AppComponent, AfterLoginComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    // AuthModule,

    // provideFirebaseApp(() => initializeApp(environment.firebase)),

    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AuthorizedLayoutComponent,
    UnauthorizedLayoutComponent,
    ApiModule.forRoot({
      basePath: environment.backendDomain,
      // apiKey: environment.apiKey,
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // NOTE: the Firebase messaging SW is registered at runtime by
    // MessagingService.requestForToken() via navigator.serviceWorker.register()
    // against the root '/firebase-messaging-sw.js'. The previous
    // ServiceWorkerModule.register('/service-worker/firebase-messaging-sw.js')
    // pointed at a path that does not exist (404) and misused the Angular SW
    // module for a non-NGSW worker, so it was removed.

    // WrappedRouterOutletDirective,

    // provideFirebaseApp(() => initializeApp(environment.firebase)),
    // provideAnalytics(() => getAnalytics()),
    // provideAuth(() => getAuth()),
    // provideDatabase(() => getDatabase()),
    // provideFirestore(() => getFirestore()),
    // provideFunctions(() => getFunctions()),
    // provideMessaging(() => getMessaging()),
    // providePerformance(() => getPerformance()),
    // provideRemoteConfig(() => getRemoteConfig()),
    // provideStorage(() => getStorage())
    // provideMessaging(() => getMessaging())
    MarkdownModule.forRoot(),
    QuillModule.forRoot(),
    BackendLoadingComponent,
  ],
  providers: [
    // { provide: PERSISTENCE, useValue: 'session' },
    { provide: PERSISTENCE, useValue: 'local' },
    { provide: USE_DEVICE_LANGUAGE, useValue: true },
    // ScreenTrackingService, UserTrackingService
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    AccountService,
    MessagingService,
    ProjectsService,
    // provideHttpClient(),
    ApiAuthenticatedService,
    provideHttpClient(
      withInterceptors([coldStartInterceptorFn, authInterceptorFn, featureGate403InterceptorFn])
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMessaging(() => getMessaging()),
    {
      // Cattura ?ref= prima di qualunque navigazione: il redirect di Firebase
      // riscrive l'url e il parametro sparirebbe.
      provide: APP_INITIALIZER,
      multi: true,
      deps: [ReferralService],
      useFactory: (referral: ReferralService) => () => referral.captureFromUrl(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
